import React from 'react';
import { withRouter } from '../../Utils/Component';
import { Result, Button } from 'antd';

function Page404() {
    return (
        <Result
			status="404"
			title="404"
			subTitle="Sorry, the page you visited does not exist."
			extra={<Button type="primary" onClick={() => this.window.close()}>Back Home</Button>}
		/>
    )
}

export default withRouter(Page404);